import { format } from "date-fns";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer class="bg-black pt-4">
      <div class="container d-none d-md-block">
        <div class="row">
          <div class="col-md-1 d-flex justify-content-center justify-content-md-center me-2">
            <img
              src="/assets/img/marca/antesala-logo-white.svg"
              width="100px"
              alt=""
            />
          </div>
          <div class="col-md-2">
            <ul class="mb-0 p-0">
              <li class="pb-2">
                <Link to="/somos" class="GothamLight fc-blanco">
                  Quienes Somos
                </Link>
              </li>
              <li class="pb-2">
                <a href="#" class="GothamLight fc-blanco">
                  Pauta con nosotros
                </a>
              </li>
              <li class="pb-2">
                <Link
                  to="/terminos-y-condiciones"
                  class="GothamLight fc-blanco"
                >
                  Términos y Condiciones
                </Link>
              </li>
            </ul>
          </div>
          <div class="col-md-2">
            <h1
              class="GothamLight fc-blanco mt-4 mt-md-0 fw-bold"
              style={{ fontSize: "13px" }}
            >
              SALAS Y PRODUCTORXS
            </h1>
            <ul class="p-0">
              <li class="pb-2">
                <Link to="/login" class="GothamLight fc-blanco">
                  Iniciar Sesión
                </Link>
              </li>
              <li class="pb-2">
                <Link to="/registro/2" class="GothamLight fc-blanco">
                  Registrarse
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-2">
            <h1
              class="GothamLight fc-blanco mt-4 mt-md-0 fw-bold"
              style={{ fontSize: "13px" }}
            >
              USUARIOS
            </h1>
            <ul class="mb-0 p-0">
              <li class="pb-2">
                <Link to="/login" class="GothamLight fc-blanco">
                  Iniciar Sesión
                </Link>
              </li>
              <li>
                <Link to="/registro/1" class="GothamLight fc-blanco">
                  Registrate
                </Link>
              </li>
              <li class="pb-2">
                <a href="#" class="GothamLight fc-blanco">
                  Recuperar Cuenta
                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-2">
            <ul class="mb-0 p-0 mt-4 mt-md-0">
              <li class="pb-2">
                <a href="#" class="fs-3 fc-blanco me-2">
                  <i class="bi bi-facebook"></i>
                </a>
                <a href="#" class="fs-3 fc-blanco me-2">
                  <i class="bi bi-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#" class="GothamLight fc-blanco">
                  antesala.cordoba@gmail.com
                </a>
              </li>
              <li className="d-flex">
                <img
                  src="/assets/img/tarjeta-naranja.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/mastercard.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/maestro.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/cabal.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/amex.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
                <img
                  src="/assets/img/visa.svg"
                  className="img-fluid"
                  style={{ width: "50px" }}
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container d-block d-md-none">
        <div class="row">
          <div class="col-md-2">
            <button
              class="w-100  text-start btn btn-transparent px-0 text-white border-bottom"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseInfo"
              aria-expanded="false"
              aria-controls="collapseInfo"
            >
              INFO
            </button>

            <div class="collapse" id="collapseInfo">
              <ul class="mb-0 p-0">
                <li class="pb-2">
                  <Link to="/somos" class="GothamLight fc-blanco">
                    Quienes Somos
                  </Link>
                </li>
                <li class="pb-2">
                  <a href="#" class="GothamLight fc-blanco">
                    Pauta con nosotros
                  </a>
                </li>
                <li class="pb-2">
                  <Link
                    to="/terminos-y-condiciones"
                    class="GothamLight fc-blanco"
                  >
                    Términos y Condiciones
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-2">
            <button
              class="w-100  text-start btn btn-transparent px-0 text-white border-bottom"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSalasProductores"
              aria-expanded="false"
              aria-controls="collapseSalasProductores"
            >
              SALAS Y PRODUCTORXS
            </button>

            <div class="collapse" id="collapseSalasProductores">
              <ul class="p-0">
                <li class="">
                  <Link to="/login" class="GothamLight fc-blanco">
                    Iniciar Sesión
                  </Link>
                </li>
                <li class="">
                  <Link to="/registro/2" class="GothamLight fc-blanco">
                    Registrarse
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-2">
            <button
              class="w-100  text-start btn btn-transparent px-0 text-white border-bottom"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseUsuarios"
              aria-expanded="false"
              aria-controls="collapseUsuarios"
            >
              USUARIOS
            </button>

            <div class="collapse" id="collapseUsuarios">
              <ul class="mb-0 p-0">
                <li class="">
                  <Link to="/login" class="GothamLight fc-blanco">
                    Iniciar Sesión
                  </Link>
                </li>
                <li>
                  <Link to="/registro/1" class="GothamLight fc-blanco">
                    Registrate
                  </Link>
                </li>
                <li class="">
                  <Link to="/recuperar" class="GothamLight fc-blanco">
                    Recuperar Cuenta
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-2 py-2">
            <ul class="list-group list-group-horizontal d-flex align-items-center">
              <li class="list-group-item bg-transparent border-0">
                <img
                  src="/assets/img/marca/antesala-logo-white.svg"
                  width="50px"
                  alt=""
                />
              </li>
              <li class="list-group-item bg-transparent border-0 d-flex">
                <a href="#" class="fs-3 fc-blanco me-2">
                  <i class="bi bi-facebook"></i>
                </a>
                <a href="#" class="fs-3 fc-blanco me-2">
                  <i class="bi bi-instagram"></i>
                </a>
              </li>
              <li className="list-group-item bg-transparent border-0">
                <a href="#" class="GothamLight text-white" style={{fontSize: "14px"}}>
                  antesala.cordoba@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container-fluid bg-white p-2">
        <p class="Grifter m-0" style={{fontSize: "12px"}}>{`© Copyright - 2022 - ${format(
          new Date(),
          "Y"
        ).toString()} | Antesala.`}</p>
      </div>
    </footer>
  );
};

export default Footer;
